import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Product } from '../../../../../generated/generated-types';
import { ProductDispositionOverviewPanelComponent } from '../product-disposition-overview-panel/product-disposition-overview-panel.component';

@Component({
  selector: 'app-formly-product-disposition-overview-list-widget',
  templateUrl: './formly-product-disposition-overview-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ProductDispositionOverviewPanelComponent],
})
export class FormlyProductDispositionOverviewListWidgetComponent extends FieldType<FieldTypeConfig> implements OnInit {

  private readonly destroyRef = inject(DestroyRef);

  readonly productId = signal<string | undefined>(undefined);

  ngOnInit(): void {
    this.syncProductId(this.model as Product | undefined);

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: Product) => {
        this.syncProductId(value);
      });
  }

  private syncProductId(product: Product | undefined): void {
    const id = product?.id;
    if (id && id !== this.productId()) {
      this.productId.set(id);
    } else if (!id) {
      this.productId.set(undefined);
    }
  }
}
